const common = {
    black: "#000000",
    white: "#FFFFFF",
};

export default common;
